// 商品计费属性模块
import * as type from "../mutation-types"
const state = {
  data:window.localStorage.getItem("billingAttributes") || ""
}

const getters = {
  getBillingAttributes:state=>state.data
}

const mutations = {
  [type.USER_OUT_LOGIN](state){
    state.data = null
  }
}

const actions = {
  onUse(response){
    window.localStorage.setItem("billingAttributes",response)
  },
  outLogin({commit}){
    commit(type.USER_OUT_LOGIN)
    window.localStorage.removeItem("billingAttributes")
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
